import { Dispatch, SetStateAction } from 'react';

import { CustomDialog } from '@ui/uikit/components/common/Dialog';

type SubmitYourAppModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onClose?: () => void;
};

export const SubmitYourAppModal = ({ isOpen, setIsOpen }: SubmitYourAppModalProps) => {
  const onOpenChangeHandler = (opened: boolean) => {
    setIsOpen(opened);
  };

  return (
    <CustomDialog
      open={isOpen}
      onOpenChange={onOpenChangeHandler}
      title="List your Project on Magic Store"
      titleIsLeftAligned
      noSidePadding
    >
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdEDd1Eu6LQ-kwyww3OnZjqjATQXIEr2ATKh9Bk8--5z0uzdA/viewform?embedded=true"
        width="100%"
        height="100%"
        title="Submit Your App Form"
        name="submitYourAppForm"
        className="h-[calc(100vh-240px)]"
      >
        Loading…
      </iframe>
    </CustomDialog>
  );
};
